var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-tabs",
        { attrs: { centered: "", "icons-and-text": "" } },
        [
          _c(
            "v-tab",
            {
              key: "general",
              attrs: { to: _vm.baseAddress + "edit/" + _vm.userId + "/basic" }
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("settings.users.menu.personalData")) + " "
              ),
              _c("v-icon", [_vm._v("account_box")])
            ],
            1
          ),
          this.$store.getters["companyContext"] != null &&
          _vm.$store.getters["userProperties"].system_settings
            .is_module_delegation_enabled === 2
            ? _c(
                "v-tab",
                {
                  key: "delegations",
                  attrs: {
                    to: _vm.baseAddress + "edit/" + _vm.userId + "/delegation"
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("settings.users.menu.delegationPreferencesData")
                      ) +
                      " "
                  ),
                  _c("v-icon", [_vm._v("fa-suitcase")])
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-tab",
            {
              key: "permissions",
              attrs: {
                to:
                  _vm.baseAddress +
                  "edit/" +
                  _vm.userId +
                  "/roles-and-permissions"
              }
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("settings.users.menu.rolesAndPermissions")) +
                  " "
              ),
              _c("v-icon", [_vm._v("pan_tool")])
            ],
            1
          ),
          this.$store.getters["companyContext"] != null &&
          (_vm.$store.getters["userProperties"].system_settings
            .is_module_travel_service_enabled === 2 ||
            _vm.$store.getters["userProperties"].system_settings
              .is_module_delegation_enabled === 2)
            ? _c(
                "v-tab",
                {
                  key: "costCentre",
                  attrs: {
                    to: _vm.baseAddress + "edit/" + _vm.userId + "/cost-centre"
                  }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("settings.users.menu.costCentre")) + " "
                  ),
                  _c("v-icon", [_vm._v("fa-vote-yea")])
                ],
                1
              )
            : _vm._e(),
          this.$store.getters["companyContext"] != null &&
          this.$store.state.Auth.isWnt === false
            ? _c(
                "v-tab",
                {
                  key: "additionalData",
                  attrs: {
                    to:
                      _vm.baseAddress +
                      "edit/" +
                      _vm.userId +
                      "/additional-data"
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("settings.users.menu.additionalData")) +
                      " "
                  ),
                  _c("v-icon", [_vm._v("fa-cog")])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }